// Loader.js
import React from 'react';

const PageLoader = ({text}) => (
  <div className="flex h-96 items-center justify-center">
    <div className="flex items-center gap-3">
      <div
        className="h-6 w-6 animate-spin rounded-full border-[3px] border-solid border-t-transparent"
        style={{ borderColor: '#0C66E4 transparent #0C66E4 transparent' }}
      ></div>
      <div className="text-sm text-ink-subtlest">{ text || "Laden even geduld aub..."}</div>
    </div>
  </div>
);

export default PageLoader;
